/**
 * @generated SignedSource<<24fefe55257086bd7bdf1d62c3cf6d96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AskFellowPanelInnerAddQAndAToNoteMutation$variables = {
  messageId: string;
};
export type AskFellowPanelInnerAddQAndAToNoteMutation$data = {
  readonly askCopilotAddQAndAToNote: {
    readonly message: {
      readonly id: string;
    };
  } | null;
};
export type AskFellowPanelInnerAddQAndAToNoteMutation = {
  response: AskFellowPanelInnerAddQAndAToNoteMutation$data;
  variables: AskFellowPanelInnerAddQAndAToNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "messageId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "messageId",
        "variableName": "messageId"
      }
    ],
    "concreteType": "AskCopilotAddQAndAToNote",
    "kind": "LinkedField",
    "name": "askCopilotAddQAndAToNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AskCopilotMessage",
        "kind": "LinkedField",
        "name": "message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowPanelInnerAddQAndAToNoteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskFellowPanelInnerAddQAndAToNoteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5aac07686eef95e96ffe0badb82acf1e",
    "id": null,
    "metadata": {},
    "name": "AskFellowPanelInnerAddQAndAToNoteMutation",
    "operationKind": "mutation",
    "text": "mutation AskFellowPanelInnerAddQAndAToNoteMutation(\n  $messageId: ID!\n) {\n  askCopilotAddQAndAToNote(messageId: $messageId) {\n    message {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d90f1b083253dca03bc432cbbcfd689";

export default node;
